import { updatePricingTimeRequest } from "../../data/pricingTimeApi";
import { validatePricingTimePayload } from "../validator/validatePricingTimePayload";

export async function updatePricingTimeUseCase(payload) {
  const error = validatePricingTimePayload(payload, { requireId: true });

  if (error) {
    throw new Error(error);
  }

  return await updatePricingTimeRequest(payload);
}
